import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function attendingReducer(state = initialState.attending, action) {
  switch (action.type) {
    case types.LOAD_ATTENDING_SUCCESS:
      return action.attending;
    case types.SIGNUP_OPTIMISTIC:
      return action.attending;
    case types.UN_SIGNUP_OPTIMISTIC:
      return state.filter(
        attending => attending.id !== action.attending.id
      );
    default:
      return state;
  }
}
